import { network } from 'services/network';

export const deleteCustomCluster = (params) => {
    const url = `api/bo/deleteCustomCluster?clusterId=${params}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
